export const DASHBOARD_MAIN_CONFIG = {
  noSubscriptionList: {
    title: "Subscription Details",
    noSubLabel: "No active subscriptions",
  },
  yearly_plan_sale_banner: {
    // savings: {
    //   beforeText: "Save ",
    //   afterText: "with Yearly Plan!",
    // },
    title: `Save up to <span class="text-type-accent">{0}%</span> with a Yearly Plan`,
    description:
      "Switch to a yearly plan and enjoy the same features and benefits for less.",
    button: {
      text: "Switch to yearly",
    },
  },
};

export type TDashboardMainConfig = typeof DASHBOARD_MAIN_CONFIG;
